module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container",
    class: _vm.lang
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('section', {
    staticClass: "login-content"
  }, [_c('h1', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('signup.signup')))]), _vm._v(" "), (_vm.message) ? _c('div', [_c('div', {
    staticClass: "alert"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.resetResponse
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" " + _vm._s(_vm.message) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', [_c('div', {
    staticClass: "alert"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.clearError
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" " + _vm._s(_vm.error) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('v-form', {
    ref: "signupForm"
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('user-params.username'),
      "rules": _vm.validate.usernameRules(_vm.$t),
      "color": "white",
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('user-params.email'),
      "rules": _vm.validate.emailRules(_vm.$t),
      "color": "white",
      "required": "",
      "autocomplete": "email"
    },
    model: {
      value: (_vm.useremail),
      callback: function($$v) {
        _vm.useremail = $$v
      },
      expression: "useremail"
    }
  }), _vm._v(" "), _c('v-card', {
    staticClass: "mt-4 ma-1 pa-3 body-2 grey black--text",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "EULA"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('signup.agreement_msg'))
    }
  })]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "agree_checkbox mt-3",
    attrs: {
      "label": _vm.$t('activate.agree'),
      "rules": _vm.checkboxRules
    },
    model: {
      value: (_vm.agree),
      callback: function($$v) {
        _vm.agree = $$v
      },
      expression: "agree"
    }
  }), _vm._v(" "), _c('v-btn', {
    class: !_vm.agree || _vm.done ? 'grey lighten-1' : 'blue',
    attrs: {
      "color": "blue",
      "dark": "",
      "disabled": !_vm.agree || _vm.done
    },
    on: {
      "click": _vm.checkCreds
    }
  }, [_vm._v("\n            " + _vm._s(_vm.done ? _vm.$t('signup.btn_check_email') : _vm.$t('signup.register')) + "\n        ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:%68%61%72%70%73%2d%73%75%70%70%6f%72%74%40%61%70%6c%69%78%2e%63%6f%2e%6a%70"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('signup.buy_iotizr')) + "\n        ")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "350"
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v(_vm._s(_vm.$t("signup.signupConfirmDialogText")))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmDialog = false;
        _vm.window.grecaptcha.execute();
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "350"
    },
    model: {
      value: (_vm.okDialog),
      callback: function($$v) {
        _vm.okDialog = $$v
      },
      expression: "okDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    attrs: {
      "id": "OKDIALOG"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('signup.signupSuccessDialogText'))
    }
  })]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "flat"
    },
    on: {
      "click": function($event) {
        _vm.signUpCompleted()
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "350"
    },
    model: {
      value: (_vm.errorDialog),
      callback: function($$v) {
        _vm.errorDialog = $$v
      },
      expression: "errorDialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorDialogMessage)
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "flat"
    },
    on: {
      "click": function($event) {
        _vm.errorDialog = false
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "g-recaptcha",
    attrs: {
      "data-size": "invisible"
    }
  })], 1), _vm._v(" "), _c('login-footer')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-4977bc2f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Signup.vue
// module id = 1927
// module chunks = 0